import type { ReactNode } from "react";
import type { ClassDisplayInfo } from "../../hooks/useClassDisplayInfo";
import JoinClassForm from "./JoinClassForm";
import { ClassMemberJoinSteps, type ClassMemberJoin } from "./useClassMemberJoin";
import WelcomeCode from "./WelcomeCode";

interface ClassMemberJoinScreensProps {
    join: ClassMemberJoin;
    joinInfo: ClassDisplayInfo | null;
    entry: ReactNode;
}

const ClassMemberJoinScreens = (props: ClassMemberJoinScreensProps) => {
    switch (props.join.step) {
        case ClassMemberJoinSteps.WELCOME:
            return (
                <WelcomeCode
                    loginCode={props.join.loginCode}
                    onDone={props.join.finish}
                    onShowLater={props.join.finishAndRemindLater}
                />
            );
        case ClassMemberJoinSteps.JOIN:
            return (
                <JoinClassForm
                    className={props.joinInfo?.className ?? ""}
                    teacherDisplayName={props.joinInfo?.teacherDisplayName ?? ""}
                    lockedName={props.join.registeredName}
                    isSubmitting={props.join.isSubmitting}
                    error={props.join.error}
                    onSubmit={props.join.register}
                    onBack={props.join.cancelJoin}
                />
            );
        case ClassMemberJoinSteps.ENTRY:
            return <>{props.entry}</>;
    }
};

export default ClassMemberJoinScreens;
